const local = true
let hostname = window.location.hostname
if ((!hostname || hostname === 'localhost') && !local)
  hostname = '103.175.234.164'
const url = `https://aidsmemuk.net`
export default url
